<template>
    <div class="taskdiv">
        <!-- append-to-body：弹窗与遮罩渲染到 body，避免遮罩被 street-anim（will-change 创建的包含块）
     限制在街道区域内；否则共享 v-modal 单例被其他弹窗搬到 body 后，关闭时遗留全页遮罩阻断一切点击 -->
<el-dialog :top="dialogTop" customClass="wrap" :close-on-click-modal="false" :title="dialogTitle" :visible.sync="dialogTableVisible" :before-close="ai_dialog_close" append-to-body>
            <div class="taskbg" v-loading="loading" element-loading-background="transparent">
                <!-- 任务选择：该 NPC 同时有多个可接任务，由玩家自行挑选（2026-10-28 起） -->
                <div v-if="dialogMode === 'choose'" class="taskchoose">
                    <div class="taskchoose-tip">{{ chooseTip }}</div>
                    <div class="taskchoose-list">
                        <div class="taskchoose-item"
                             v-for="option in taskOptions"
                             :key="option.optionKey"
                             @click="selectTaskOption(option)">
                            <div class="taskchoose-head">
                                <span class="taskchoose-name">{{option.taskName}}</span>
                                <span class="taskchoose-badges">
                                    <em v-for="(label, li) in option.labels"
                                        :key="li"
                                        :class="['taskchoose-badge', option.source === 'common' ? 'badge-common' : 'badge-special']">{{label}}</em>
                                </span>
                            </div>
                            <div class="taskchoose-desc" v-if="option.taskDesc">{{option.taskDesc}}</div>
                        </div>
                    </div>
                </div>
                <template v-else>
                <div class="backto-choose" v-if="hasTaskOptions" @click="backToChoose">← 看看别的委托</div>
                <div class="ring-tip" v-if="fantasyTaskBO.ring">环任务 · 第 {{fantasyTaskBO.ring}}/{{ringMax}} 环</div>
                <div id="taskdone" v-if="taskDoneMsg != null">
                    <div id="taskdonemsg">{{taskDoneMsg}}</div>
                    <div id="taskdonereward" v-if="taskDoneRewardMsg != null && taskDoneRewardMsg != ''" v-html="taskDoneRewardMsg"></div>
                </div>
                <div id="taskdesc" v-if="fantasyTaskBO.taskDesc != null" v-html="fantasyTaskBO.taskDesc">
                </div>
                <div id="taskreward" v-show="taskrewardList != null && taskrewardList.length > 0">
                    完成任务后，您能获得如下奖励：
                    <div v-for="(taskreward,index) in taskrewardList" v-bind:key="index" 
                    ref="taskreward">
                        <div class="rewarddiv" v-if="taskreward.type==1">
                            经验：{{displayNum(taskreward)}}
                        </div>
                        <div class="rewarddiv" v-if="taskreward.type==2">
                            金钱：{{displayNum(taskreward)}}
                        </div>
                        <div class="rewarddiv" v-if="taskreward.type==3">
                            <span v-if="fantasyTaskBO.taskStatus==0">随机属性点：1</span>
                            <span v-else>{{propLabel(taskreward)}}：1</span>
                        </div>
                        <div class="rewarddiv" v-if="taskreward.type==4">
                            {{taskreward.value}} * {{taskreward.count}}
                        </div>
                    </div>
                    <div class="rewarddiv" v-if="itemRewardMoney!=null">
                        额外奖励金钱：{{itemRewardMoney}}
                    </div>
                    <!-- 评分额外奖励（2026-10-31）：达标才给，接任务时就把金额讲清楚，
                         并明确告知是否已含在上面的金钱里，避免玩家以为没发 -->
                    <div class="rewarddiv" v-if="fantasyTaskBO.itemScore>0 && fantasyTaskBO.scoreBonusMoney>0">
                        评分额外奖励：<span style="color:#e6a23c">{{fantasyTaskBO.scoreBonusMoney}} 元</span>
                        <span>（交付评分 ≥ {{fantasyTaskBO.itemScore}} 分的制造品才有，已含在奖励总额内）</span>
                    </div>
                </div>
                </template>
                <div v-show="taskbutton && dialogMode !== 'choose'" class="taskbutton">
                    <template v-if="previewMode">
                        <el-button size="mini" @click="confirmAcceptTask();" type="primary" style="float:left">接受</el-button>
                        <el-button size="mini" @click="cancelPreviewTask();" style="float:right">取消</el-button>
                    </template>
                    <template v-else>
                        <el-button size="mini" @click="ai_dialog_close" type="primary" :style="taskNoRefuse ? 'display:block;margin:0 auto;float:none' : 'float:left'">好的</el-button>
                        <el-button v-if="!taskNoRefuse" size="mini" @click="refuseTask(fantasyTaskBO.taskFrom);" style="float:right">放弃</el-button>
                    </template>
                </div>
                <div v-show="dialogMode === 'choose'" class="taskbutton">
                    <el-button size="mini" @click="ai_dialog_close" style="display:block;margin:0 auto;float:none">以后再帮</el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import {postRequest} from '../../utils/api'
import Message from 'element-ui/lib/message'

// 属性代码 → 中文名兜底映射，与后端 PropTypeEnum 保持一致。
// 正常情况下后端 RewardDisplayUtil 已翻译好 displayValue，这里只防接口缺字段。
const PROP_TYPE_LABELS = {
    rongmao: '容貌', yili: '毅力', bili: '臂力', wuxing: '悟性',
    reqing: '热情', sangyin: '嗓音', poli: '魄力', fanying: '反应',
    yinyue: '音乐', meishu: '美术', wenxue: '文学', biaoyan: '表演',
    koucai: '口才', ganshou: '感受', chuangyi: '创意', jingying: '经营',
    renyuan: '人缘', daode: '道德', keji: '科技', youxi: '游戏',
    yingshi: '影视'
}

export default {
  name: 'npcTaskDialog',
  data() {
    return {
        loading: false,
        dialogTableVisible: false,
        fantasyTaskBO: {},
        taskrewardList: [],
        itemRewardMoney: null,
        level: null,
        taskbutton: true,
        previewMode: false,
        taskToken: null,
        taskNoRefuse: false,
        taskDoneMsg: null,
        taskDoneRewardMsg: null,
        ringMax: 10,
        // 一个 NPC 同时有多个可接任务时的选择界面：choose=选择列表，detail=原有的任务详情
        dialogMode: 'detail',
        taskOptions: [],
        hasTaskOptions: false,
        currentNpcId: null,
        npcName: '',
        isMobile: window.innerWidth <= 768
    };
  },
  computed: {
    dialogTop: function() {
      return this.isMobile ? '0' : '15vh';
    },
    dialogTitle: function() {
      if (this.dialogMode === 'choose') {
        return this.npcName ? (this.npcName + ' 的委托') : '选择任务';
      }
      return this.fantasyTaskBO.taskName;
    },
    chooseTip: function() {
      return (this.npcName ? this.npcName : '他') + '手头有好几件事，你想先帮哪一件？';
    }
  },
  methods: {
    // 奖励展示值：优先用后端下发 displayValue（六章①，含等级/任务系数），缺失时兜底按旧式
    displayNum(tr) {
      if (tr && tr.displayValue != null && tr.displayValue !== '') {
        return tr.displayValue;
      }
      if (tr && tr.type == 2) {
        return Math.floor(Number(tr.value) * (1 + 0.1 * (this.level || 0)));
      }
      return tr ? Number(tr.value) * ((this.level || 0) + 1) : '';
    },
    /**
     * 点「接任务」：先拉预览。
     * 该 NPC 有多个可接任务时后端只回候选清单 → 切到选择界面；只有一个任务时直接展示详情（与原流程一致）。
     */
    acceptTask: function(npcId) {
        this.currentNpcId = npcId;
        this.taskOptions = [];
        this.hasTaskOptions = false;
        this.dialogMode = 'detail';
        this.requestTaskPreview(npcId, null);
    },
    // 选择界面：玩家点中某一个任务 → 带 optionKey 精确预览该任务
    selectTaskOption: function(option) {
        if (!option || !option.optionKey) {
            return;
        }
        // 保留候选清单，详情页还能「看看别的委托」返回
        this.requestTaskPreview(this.currentNpcId, option.optionKey, true);
    },
    // 详情页返回选择列表（仅当该 NPC 有多个可接任务时出现）
    backToChoose: function() {
        if (!this.taskOptions.length) {
            return;
        }
        this.previewMode = false;
        this.taskToken = null;
        this.dialogMode = 'choose';
    },
    requestTaskPreview: function(npcId, optionKey, keepOptions) {
        let _this = this;
        _this.dialogTableVisible = true;
        _this.loading = true;
        _this.taskbutton = true;
        _this.previewMode = true;
        _this.fantasyTaskBO = {};
        _this.taskrewardList = [];
        _this.itemRewardMoney = null;
        _this.taskDoneMsg = null;
        _this.taskDoneRewardMsg = null;
        if (!keepOptions) {
            _this.taskOptions = [];
            _this.hasTaskOptions = false;
        }
        let params = {npcId: npcId};
        if (optionKey) {
            params.optionKey = optionKey;
        }
        postRequest('/task/task/previewTask', params).then(resp=> {
            _this.loading = false;
            if (resp.status == 200) {
            //成功
            const respData = resp.data;
            if (200 == respData.status) {
                const data = respData.data;
                // 多个可接任务：切到选择界面（此时任务尚未生成，也没有 taskToken）
                if (data && data.taskOptions && data.taskOptions.length > 1) {
                    _this.taskOptions = data.taskOptions;
                    _this.npcName = data.npcName || '';
                    _this.hasTaskOptions = true;
                    _this.dialogMode = 'choose';
                    _this.previewMode = false;
                    return;
                }
                if (null != data) {
                    // 单一任务（或玩家已选定）：回到原有的任务详情流程
                    if (!keepOptions) {
                        _this.taskOptions = [];
                        _this.hasTaskOptions = false;
                    }
                    _this.dialogMode = 'detail';
                    _this.applyTaskPreview(data);
                } else {
                Message.error("谢谢，我现在没有什么需要你去做的了。");
                this.dialogTableVisible = false;
                }
            } else {
                Message.error(respData.message);
                // 候选被接走等业务失败：候选清单还在手里，回选择列表让玩家换一个，
                // 而不是把整个弹窗关掉让玩家重新点「接任务」
                if (keepOptions && _this.taskOptions.length) {
                    _this.dialogMode = 'choose';
                    _this.previewMode = false;
                    _this.taskToken = null;
                } else {
                    _this.dialogTableVisible = false;
                }
            }
            } else {
            //失败
            Message.error('用户非法⊙﹏⊙∥!');
            }
        }, resp=> {
            this.loading = false;
            Message.error('用户非法⊙﹏⊙∥!');
            // 网络失败同样回选择列表（保持与业务失败一致的续选体验）
            if (keepOptions && _this.taskOptions.length) {
                _this.dialogMode = 'choose';
                _this.previewMode = false;
                _this.taskToken = null;
            } else {
                _this.dialogTableVisible = false;
            }
        });
    },
    // 预览数据 → 弹窗内容（原 acceptTask 内的填充逻辑，抽出以便选择流程复用）
    applyTaskPreview: function(data) {
        this.fantasyTaskBO = data.fantasyTaskTodoBO;
        this.taskrewardList = data.fantasyRewardBOList;
        this.level = data.level;
        if (data.taskExistFlag == true) {
            // 该NPC已有玩家的待办任务：仅展示已接任务内容（任务链任务不能拒绝）
            this.previewMode = false;
            this.taskNoRefuse = true;
        } else {
            this.taskToken = data.taskToken;
            this.previewMode = true;
        }
    },
    confirmAcceptTask: function() {
        let _this = this;
        _this.loading = true;
        postRequest('/task/task/acceptTask', {
            taskToken: _this.taskToken
        }).then(resp=> {
            _this.loading = false;
            if (resp.status == 200) {
            //成功
            const respData = resp.data;
            if (200 == respData.status) {
                if (null != respData.data) {
                    _this.fantasyTaskBO = respData.data.fantasyTaskTodoBO;
                    _this.taskrewardList = respData.data.fantasyRewardBOList;
                    _this.level = respData.data.level;
                    _this.previewMode = false;
                    // 接受成功后关闭任务弹窗
                    _this.dialogTableVisible = false;
                    _this.resetTaskChoose();
                    Message.success("任务接受成功！");
                    let npclist = respData.data.npclist;
                    if (npclist != null) {
                        _this.$store.commit('street/SET_NPCLIST', npclist);
                    }
                    
                    // 接受任务后，更新当前任务列表
                    _this.$store.dispatch('street/fetchTaskList');
                } else {
                Message.error("谢谢，我现在没有什么需要你去做的了。");
                this.loading = false;
                this.dialogTableVisible = false;
                }
            } else {
                Message.error(respData.message);
                this.loading = false;
                this.dialogTableVisible = false;
            }
            } else {
            //失败
            Message.error('用户非法⊙﹏⊙∥!');
            }
        }, resp=> {
            this.loading = false;
            this.dialogTableVisible = false;
            Message.error('用户非法⊙﹏⊙∥!');
        });
    },
    cancelPreviewTask: function() {
        this.previewMode = false;
        this.taskToken = null;
        this.dialogTableVisible = false;
        this.resetTaskChoose();
    },
    completeTask: function(npcId) {
        let _this = this;
        _this.resetTaskChoose();
        _this.dialogTableVisible = true;
        _this.loading = true;
        _this.fantasyTaskBO = {};
        _this.taskrewardList = [];
        _this.itemRewardMoney = null;
        postRequest('/task/task/completeTask', {
            npcId: npcId
        }).then(resp=> {
            _this.loading = false;
            if (resp.status == 200) {
            //成功
            const respData = resp.data;
            if (200 == respData.status) {
                let npclist = respData.data.npclist;
                _this.level = respData.data.level;
                if (npclist != null) {//说明是完成状态，更新npclist
                    _this.$store.commit('street/SET_NPCLIST', npclist);
                    _this.fantasyTaskBO = respData.data.fantasyTaskBO;
                    _this.taskrewardList = respData.data.fantasyRewardList;
                    if (respData.data.itemRewardMoney != null) {
                        _this.itemRewardMoney = respData.data.itemRewardMoney;
                    }
                    _this.taskbutton = false;
                    setTimeout(function(){
                        _this.dialogTableVisible = false;
                    },1000);
                    setTimeout(function(){
                        _this.taskbutton = true;
                    },1000);
                    Message.success(respData.message);
                    // 完成即刷新用户详情（经验/金钱），底部经验条即时更新
                    _this.$store.dispatch('user/fetchUserDetail');
                    // 评定市民完成：弹窗告知住所分配与回家解锁（否则玩家无从知晓）
                    if (respData.data.homeTip) {
                        _this.$alert(respData.data.homeTip, '新住所解锁', {confirmButtonText: '知道了', appendToBody: true, type: 'success'});
                    }
                } else {
                    //未完成状态
                    _this.fantasyTaskBO = respData.data.fantasyTaskBO;
                    _this.taskrewardList = respData.data.fantasyRewardList;
                }

                // 完成任务后，更新当前任务列表
                _this.$store.dispatch('street/fetchTaskList');
            } else {
                Message.error(respData.message);
            }
            } else {
                //失败
                Message.error('用户非法⊙﹏⊙∥1!');
            }
        }, resp=> {
            this.loading = false;
            this.dialogTableVisible = false;
            Message.error('用户非法⊙﹏⊙∥2!');
        });
    },
    refuseTask: function(npcId){
      let _this = this;
      _this.loading = true;
      this.$confirm('您确定要推掉任务吗，推掉任务会有0.5倍于任务奖励的经验值惩罚哦?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        postRequest("/task/task/refuseTask", {
          npcId: npcId
        }).then(resp=> {
            _this.loading = false;
            _this.dialogTableVisible = false;
            if (resp.status == 200) {
            //成功
            const respData = resp.data;
            if (200 == respData.status) {
                _this.taskrewardList = respData.data.fantasyRewardList;
                const npclist = respData.data.npclist;
                if (npclist != null) {
                    _this.$store.commit('street/SET_NPCLIST', npclist);
                }
                
                // 拒绝任务后，更新当前任务列表
                _this.$store.dispatch('street/fetchTaskList');
                // 拒绝有 0.5 倍经验惩罚，同步刷新用户详情（底部经验条）
                _this.$store.dispatch('user/fetchUserDetail');
            } else {
                Message.error(respData.message);
            }
            } else {
            //失败
            Message.error('用户非法⊙﹏⊙∥!');
            }
        }, resp=> {
            this.loading = false;
            this.dialogTableVisible = false;
            Message.error('用户非法⊙﹏⊙∥!');
        });
      }, function () {
        //取消
        _this.loading = false;
      })
    },
    /**
     * 属性奖励的中文名：优先用后端下发的 displayValue（RewardDisplayUtil 已按属性代码翻译）；
     * 后端未下发时用本地映射兜底，最后原样返回，避免弹窗露出 reqing / sangyin 这类代码。
     */
    propLabel(reward) {
        if (reward == null) {
            return '';
        }
        if (reward.displayValue != null && reward.displayValue !== '') {
            return reward.displayValue;
        }
        const code = reward.value;
        if (code == null || code === '') {
            return '';
        }
        return PROP_TYPE_LABELS[String(code).toLowerCase()] || code;
    },
    ai_dialog_close(){
      this.dialogTableVisible = false;
      this.previewMode = false;
      this.taskToken = null;
      this.taskNoRefuse = false;
      this.taskDoneMsg = null;
      this.taskDoneRewardMsg = null;
      this.resetTaskChoose();
    },
    // 清空「多任务选择」状态，回到默认的任务详情模式
    resetTaskChoose: function() {
      this.dialogMode = 'detail';
      this.taskOptions = [];
      this.hasTaskOptions = false;
      this.npcName = '';
    },
    finishTask: function(respData) {
        let _this = this;
        // 完成信息统一在任务弹窗展示，关闭原交谈框避免重复提示
        _this.$emit('close-talk');
        if (respData.data != null) {
            if (respData.data.npclist != null) {
                let npclist = respData.data.npclist;
                //说明是完成状态，更新npclist
                _this.$store.commit('street/SET_NPCLIST', npclist);
            }
            if (respData.data.level != null) {
                _this.level = respData.data.level;
            }

            if (respData.data.fantasyTaskBO != null) {
                _this.fantasyTaskBO = respData.data.fantasyTaskBO;
            }
            let msg = "";
            let level = respData.data.level;
            if (respData.data.fantasyRewardList != null) {
                let taskrewardList = respData.data.fantasyRewardList;
                for (let i=0; i<taskrewardList.length; i++) {
                        let type = taskrewardList[i].type;
                        if (type == 1) {
                            msg += "经验值增加：" + this.displayNum(taskrewardList[i]) + "<br>";
                        }
                        if (type == 2) {
                            msg += "资金增加：" + this.displayNum(taskrewardList[i]) + "<br>";
                        }
                    if (type == 3) {
                        // 后端已把属性代码翻成中文（displayValue），前端只在缺失时兜底
                        msg += _this.propLabel(taskrewardList[i]) + "属性点增加：1<br>";
                    }
                    if (type == 4) {
                        msg += taskrewardList[i].value + " * " + taskrewardList[i].count  + "<br>";
                    }

                }
            }

            if (respData.data.itemRewardMoney != null) {
                msg += "额外奖励金钱：" + respData.data.itemRewardMoney + "<br>";
            }

            // 任务完成后统一弹窗展示：完成任务信息（NPC回应+完成奖励），有后续任务时附加新任务内容（任务链任务不能拒绝）
            _this.taskDoneMsg = respData.message;
            _this.taskDoneRewardMsg = msg;
            _this.itemRewardMoney = null;
            _this.taskNoRefuse = true;
            _this.resetTaskChoose();
            if (respData.data.nextTaskBO != null) {
                _this.fantasyTaskBO = respData.data.nextTaskBO.taskBO;
                _this.taskrewardList = respData.data.nextTaskBO.rewardList != null ? respData.data.nextTaskBO.rewardList : [];
            } else {
                // 没有后续任务：仅展示完成信息；任务链终点时展示完结语
                _this.fantasyTaskBO = {
                    taskName: '任务完成',
                    taskDesc: respData.data.nextTaskMsg != null ? respData.data.nextTaskMsg : null
                };
                _this.taskrewardList = [];
            }
            _this.dialogTableVisible = true;
            if (respData.data.fantasyUserBO != null) {
                _this.$store.commit('user/SET_FANTASY_USER', respData.data.fantasyUserBO);
            }
            // 完成任务后，更新当前任务列表
            _this.$store.dispatch('street/fetchTaskList');
            // 拜访/询问/送物完成也加经验金钱，同步刷新用户详情（底部经验条）
            _this.$store.dispatch('user/fetchUserDetail');
            // 评定市民完成（拜访路径）：弹窗告知住所分配与回家解锁
            if (respData.data.homeTip) {
                _this.$alert(respData.data.homeTip, '新住所解锁', {confirmButtonText: '知道了', appendToBody: true, type: 'success'});
            }
        }
    }
  }
}
</script>

<style scoped>
/* ===== 多可接任务：选择界面 ===== */
.taskchoose {
  padding: 4px 2px 2px;
}
.taskchoose-tip {
  margin: 2px 4px 10px;
  font-size: 13px;
  line-height: 1.6;
  color: #606266;
}
.taskchoose-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.taskchoose-item {
  padding: 10px 12px;
  border: 1px solid #e4e7ed;
  border-radius: 6px;
  background-color: #fafcfa;
  cursor: pointer;
  transition: border-color .15s ease, background-color .15s ease, box-shadow .15s ease;
}
.taskchoose-item:hover {
  border-color: #9bdf70;
  background-color: #f4fbf0;
  box-shadow: 0 2px 8px rgba(103, 194, 58, .16);
}
.taskchoose-head {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}
.taskchoose-name {
  font-size: 15px;
  font-weight: bold;
  color: #303133;
}
.taskchoose-badges {
  display: inline-flex;
  flex-wrap: wrap;
  gap: 4px;
}
.taskchoose-badge {
  font-style: normal;
  font-size: 11px;
  line-height: 17px;
  padding: 0 7px;
  border-radius: 9px;
  border: 1px solid transparent;
  white-space: nowrap;
}
/* 后台专有任务（周常/日常/剧情链…）：蓝色系 */
.taskchoose-badge.badge-special {
  color: #409eff;
  background: #ecf5ff;
  border-color: #d9ecff;
}
/* 通用委托（随机/环任务）：绿色系 */
.taskchoose-badge.badge-common {
  color: #67c23a;
  background: #f0f9eb;
  border-color: #e1f3d8;
}
.taskchoose-desc {
  margin-top: 6px;
  font-size: 13px;
  line-height: 1.6;
  color: #909399;
  word-break: break-all;
}
/* 详情页返回选择列表 */
.backto-choose {
  display: inline-block;
  margin: 0 0 6px 2px;
  font-size: 12px;
  color: #409eff;
  cursor: pointer;
}
.backto-choose:hover {
  text-decoration: underline;
}
/* 环任务进度标识（浅色胶囊，与任务列表样式统一） */
.ring-tip {
  display: inline-block;
  margin: 4px 0 8px;
  padding: 2px 10px;
  font-size: 12px;
  line-height: 18px;
  color: #e6a23c;
  background: #fdf6ec;
  border: 1px solid #f5dab1;
  border-radius: 10px;
}
a {
    cursor: pointer;
    color: blue;
}
{
    width:100%;
}
.wrap {
    margin:auto;
}
.taskbg {
    min-height: 260px;
    max-height: 60vh;
    overflow-y: auto;
}
#taskdone {
    margin: 8px 10px;
    padding: 8px;
    background-color: #f0f9eb;
    border: 1px solid #e1f3d8;
    border-radius: 4px;
    font-size: 14px;
    color: #67c23a;
}
#taskdonemsg {
    line-height: 1.6;
}
#taskdonereward {
    margin-top: 6px;
    padding-top: 6px;
    border-top: 1px dashed #c2e7b0;
    line-height: 1.6;
}
#taskdesc {
    padding:3px 5px;
    font-size:16px;
    font-weight:bold;
    letter-spacing:5px;
}
#taskreward {
    margin: 10px;
    padding:5px;
}
#taskreward .rewarddiv {
    font-size:16px;
    font-weight:bold;
    margin: 10px;
    padding:5px;
    text-align:center;
}

/* ========== 移动端适配 ========== */
@media (max-width: 768px) {
  /* 任务弹窗在移动端：限制高度 */
  .taskbg {
    height: auto;
    max-height: 55vh;
    overflow-y: auto;
  }
  #taskdesc {
    padding: 4px 6px;
    font-size: 13px;
    letter-spacing: 1px;
  }
  #taskreward { margin: 6px; padding: 3px; }
  #taskreward .rewarddiv {
    font-size: 13px;
    margin: 4px;
    padding: 3px;
  }
  /* 多任务选择：移动端压缩间距，保证一屏能看到 2~3 个委托 */
  .taskchoose-item { padding: 8px 10px; }
  .taskchoose-name { font-size: 14px; }
  .taskchoose-desc { font-size: 12px; }
  .taskchoose-badge { font-size: 10px; line-height: 16px; padding: 0 6px; }
}
</style>